import CreationToolOutputType from './output-type'
import CreationToolStep from './steps'
import CreationToolUserRestriction from './user-restriction'

enum CreationToolErrorFix {
    Supercut = 'CT_ERROR_FIX_SUPERCUT',
    SupportCenter = 'CT_ERROR_FIX_SUPPORT_CENTER',
    UploadAsGif = 'CT_ERROR_FIX_UPLOAD_AS_GIF',
    TrimVideo = 'CT_ERROR_FIX_TRIM_VIDEO',
    RetryUpload = 'CT_ERROR_FIX_RETRY_UPLOAD',
    CommunityGuidelines = 'CT_ERROR_FIX_COMMUNITY_GUIDELINES',
    TakedownAppeal = 'CT_ERROR_FIX_TAKEDOWN_APPEAL'
}

namespace CreationToolErrorFix {
    /**
     * Returns the error fix's display title.
     */
    export function title(fix: CreationToolErrorFix): string {
        switch (fix) {
            case CreationToolErrorFix.Supercut:
                return `Continue to Super Cut`
            case CreationToolErrorFix.SupportCenter:
                return `Visit Support Center`
            case CreationToolErrorFix.UploadAsGif:
                return `Upload as GIF`
            case CreationToolErrorFix.TrimVideo:
                return `Trim Video`
            case CreationToolErrorFix.RetryUpload:
                return `Retry`
            case CreationToolErrorFix.CommunityGuidelines:
                return 'Community Guidelines'
            case CreationToolErrorFix.TakedownAppeal:
                return 'Appeal this Decision'
        }
    }

    /**
     * Returns the error fix's description text.
     */
    export function description(fix: CreationToolErrorFix): string {
        switch (fix) {
            case CreationToolErrorFix.Supercut:
                return `Would you like to use Super Cut, our tool for converting longer clips into a set of GIFs?`
            case CreationToolErrorFix.SupportCenter:
                return `Please try again or visit our Support Center.`
            case CreationToolErrorFix.UploadAsGif:
                return `Would you like to upload as a GIF instead?`
            case CreationToolErrorFix.TrimVideo:
                return `Would you like to trim this video?`
            case CreationToolErrorFix.RetryUpload:
                return `Would you like to try uploading again?`
            case CreationToolErrorFix.CommunityGuidelines:
                return `Please visit our Community Guidelines.`
            case CreationToolErrorFix.TakedownAppeal:
                return ''
        }
    }

    /**
     * Returns the error fix's redirect url, if it has one.
     */
    export function url(fix: CreationToolErrorFix): string {
        switch (fix) {
            case CreationToolErrorFix.Supercut:
                return `/supercut`
            case CreationToolErrorFix.SupportCenter:
                return `https://support.giphy.com/hc/en-us/articles/360019977552-How-to-Upload`
            case CreationToolErrorFix.TrimVideo:
            case CreationToolErrorFix.UploadAsGif:
            case CreationToolErrorFix.RetryUpload:
                return ''
            case CreationToolErrorFix.CommunityGuidelines:
                return `https://support.giphy.com/hc/en-us/articles/360020286811-GIPHY-Community-Guidelines`
            case CreationToolErrorFix.TakedownAppeal:
                return `https://support.giphy.com/hc/en-us/requests/new?ticket_form_id=5222235298970`
        }
    }

    /**
     * Returns the error fix's step, if it has one.
     */
    export function step(fix: CreationToolErrorFix): CreationToolStep | null {
        switch (fix) {
            case CreationToolErrorFix.TrimVideo:
                return CreationToolStep.VideoTrim
            default:
                return null
        }
    }

    /**
     * Returns the error fix's alternative output type, if it has one.
     */
    export function outputType(fix: CreationToolErrorFix): CreationToolOutputType | null {
        switch (fix) {
            case CreationToolErrorFix.UploadAsGif:
                return CreationToolOutputType.Gif
            default:
                return null
        }
    }

    /**
     * Returns the error fix's user restrictions.
     */
    export function userRestriction(fix: CreationToolErrorFix): CreationToolUserRestriction {
        switch (fix) {
            case CreationToolErrorFix.Supercut:
                return CreationToolUserRestriction.CanAccessSuperCut
            case CreationToolErrorFix.UploadAsGif:
            case CreationToolErrorFix.TrimVideo:
            case CreationToolErrorFix.RetryUpload:
                return CreationToolUserRestriction.LoggedInOnly
            case CreationToolErrorFix.CommunityGuidelines:
            case CreationToolErrorFix.TakedownAppeal:
            case CreationToolErrorFix.SupportCenter:
                return CreationToolUserRestriction.Everyone
        }
    }
}

export default CreationToolErrorFix
